import styled from 'styled-components';

export const PhoneFieldHintText = styled.label`
  display: block;
  font-size: 12px !important;
`;

export const SignUpPhoneNumberInput = styled.div`
  input {
    border: none !important;
  }
`;
